export const DEFAULT_LOCALE = "en-US";

/** Sherlock environment descriptor used in the nav dropdown and throughout the app */
export interface Environment {
  stage: string;
  realm: string;
  label: string;
  enabled: boolean;
}

/** All supported Sherlock environments in display order */
export const ENVIRONMENTS: Environment[] = [
  { stage: 'beta', realm: 'NAAmazon',   label: 'us-east-1(Beta NA)',   enabled: true },
  { stage: 'beta', realm: 'eu-south-2', label: 'eu-south-2(Beta ZAZ)', enabled: true },
  { stage: 'beta', realm: 'FEAmazon',   label: 'us-west-2(Beta FE)',   enabled: true },
  { stage: 'prod', realm: 'NAAmazon',   label: 'us-east-1(Prod NA)',   enabled: true },
  { stage: 'prod', realm: 'eu-south-2', label: 'eu-south-2(Prod ZAZ)', enabled: true },
  { stage: 'prod', realm: 'FEAmazon',   label: 'us-west-2(Prod FE)',   enabled: true },
];

/** Realm → AWS region mapping (same as backend AppConfig profile naming) */
export const REALM_TO_REGION: Record<string, string> = {
  NAAmazon: 'us-east-1',
  'eu-south-2': 'eu-south-2',
  FEAmazon: 'us-west-2',
};

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

// IAM Role ARNs for API Gateway authentication
export const SherlockApiRoleMap = {
  "beta": {
    "us-east-1": "arn:aws:iam::489729265110:role/SherlockWebapp-ExternalReadAndWriteRole-beta-NAAmazon",
    "us-west-2": "arn:aws:iam::485614217212:role/SherlockWebapp-ExternalReadAndWriteRole-beta-FEAmazon",
    "eu-south-2": "arn:aws:iam::510912409955:role/SherlockWebapp-ExternalReadAndWriteRole-beta-eu-south-2",
  },
  "prod": {
    "us-east-1": "arn:aws:iam::484548034642:role/SherlockWebapp-ExternalReadAndWriteRole-prod-NAAmazon",
    "us-west-2": "arn:aws:iam::454685686638:role/SherlockWebapp-ExternalReadAndWriteRole-prod-FEAmazon", 
    "eu-south-2": "arn:aws:iam::953391828056:role/SherlockWebapp-ExternalReadAndWriteRole-prod-eu-south-2",
  }
};
